/**
  This file exists so that Volto can properly override the Header.
  Technically, we can put all the component code here, but for
  the sake of organization keep it with the other components
  and just import is here instead.
 */

import Header from '../../../../../components/Blocks/Header/Header';

export default Header;